import config from 'config'
import { selectSkipRefetchStore } from 'data/selectors'
import * as dateMenuSelectors from 'menu/DateMenu/selectors'
import { createLogic } from 'redux-logic'
import type { State } from 'store/types'
import { fetchAction } from 'utils'

import * as constants from './constants'

interface Action {
  storeId: number
}

const fetchStore = createLogic<State, Action>({
  type: constants.FETCH_STORE,
  latest: true,

  async process({ action, getState }, dispatch, done) {
    try {
      const state = getState()
      const baseRequestParams = dateMenuSelectors.baseRequestParams(state, action as any)
      const skipRefetch = selectSkipRefetchStore(action.payload)(state)

      if (skipRefetch) {
        dispatch({
          type: constants.FETCH_STORE_DONE,
          payload: action.payload,
        })
      } else {
        const requestParameters = {
          ...baseRequestParams,
          storeId: action.payload.storeId,
        }
        const detailsPromise = fetchAction(config.api.store, requestParameters)
        const trafficPromise = fetchAction(config.api.storeTraffic, requestParameters)
        const resultsPromise = fetchAction(config.api.storeResult, requestParameters)
        const storeReplenishmentPromise = fetchAction(config.api.storeReplenishment, requestParameters)
        const [{ data: details }, { data: traffic }, { data: results }, { data: storeReplenishment }] = await Promise.all([
          detailsPromise,
          trafficPromise,
          resultsPromise,
          storeReplenishmentPromise,
        ])

        dispatch({
          type: constants.FETCH_STORE_SUCCESS,
          payload: {
            ...action.payload,
            data: {
              details,
              traffic,
              results,
              storeReplenishment,
            },
          },
        })
      }
    } catch (error) {
      dispatch({
        ...action,
        type: constants.FETCH_STORE_ERROR,
      })
    }
    done()
  },
})

export default [fetchStore]
